import styled from 'styled-components'
import Flex from 'src/components/Layout/Flex/Flex'

export const Background = styled(Flex)`
  z-index: -1;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background-color: ${props => props.theme.colors.main.backgroundDark};
`

export const BackgroundLeftColumn = styled(Flex)`
  transform: translate(-25%, 25%) rotateY(180deg);
`

export const BackgroundRightColumn = styled(Flex)`
  transform: translate(25%, -25%) rotateX(180deg);
`

export const MainSection = styled(Flex).attrs({ as: 'section' })`
  min-height: inherit;
`
